import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import GWRAchievements from "./pages/GWRAchievements";
import RhythmicAchievements from "./pages/RhythmicAchievements";
import Callback from "./pages/CallBack";
import OnlineClassSlots from "./pages/OnlineClassSlots"
import LoginRedirect from "./pages/LoginRedirect";
import Achievements from "./pages/Achievements";
import './App.css';

const App = () => {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/achievements" element={<Achievements />} />
          <Route path="/achievements/gwr" element={<GWRAchievements />} />
          <Route path="/achievements/rhythmic" element={<RhythmicAchievements />} />
          <Route path="/slots" element={<OnlineClassSlots />} />
          <Route path="/login" element={<LoginRedirect />} />

        </Routes>
      </div>
    </Router>
  );
};

export default App;
